/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentSummary_development$ref = any;
type LocationFilter_root$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Developments_root$ref: FragmentReference;
declare export opaque type Developments_root$fragmentType: Developments_root$ref;
export type Developments_root = {|
  +developmentProducts: {|
    +totalCount: number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +$fragmentRefs: DevelopmentSummary_development$ref
      |}
    |}>,
  |},
  +$fragmentRefs: LocationFilter_root$ref,
  +$refType: Developments_root$ref,
|};
export type Developments_root$data = Developments_root;
export type Developments_root$key = {
  +$data?: Developments_root$data,
  +$fragmentRefs: Developments_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    },
    {
      "kind": "RootArgument",
      "name": "sortDirection"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Developments_root",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        },
        {
          "kind": "Variable",
          "name": "sortDirection",
          "variableName": "sortDirection"
        }
      ],
      "concreteType": "DevelopmentProductConnectionConnection",
      "kind": "LinkedField",
      "name": "developmentProducts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DevelopmentProductConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DevelopmentProduct",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DevelopmentSummary_development"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocationFilter_root"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '3bb35c51131751fba0793d32b6e0e20e';

export default node;
